import { useState } from "react";
import GoogleMapKmlLayer from "./googleMapKmlLayer/idnex";
import Gallery from "./../../../pages/imageIdentification/gallery";
import { ReactComponent as SemiVenemous } from "./../../../../assets/images/icon/semi-venemous.svg";
import { ReactComponent as Location } from "./../../../../assets/images/icon/location.svg";
import Snake from "./../../../../assets/images/picture/snake_image.png";
function ResultStep(props) {
  const [KmlLayers, setKmlLayers] = useState([
    { url: "https://rabintech.net/Vipera.kml" },
    { url: "https://rabintech.net/Vipera1.kml" },
  ]);
  const [googleMapDarkTheme, setGoogleMapDarkTheme] = useState(true);
  const [googleMapDarkStyle, setGoogleMapDarkStyle] = useState([
    {
      featureType: "all",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#ffffff",
        },
      ],
    },
    {
      featureType: "all",
      elementType: "labels.text.stroke",
      stylers: [
        {
          color: "#000000",
        },
        {
          lightness: 13,
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#000000",
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#144b53",
        },
        {
          lightness: 14,
        },
        {
          weight: 1.4,
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          color: "#08304b",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        {
          color: "#0c4152",
        },
        {
          lightness: 5,
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#000000",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#0b434f",
        },
        {
          lightness: 25,
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#000000",
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#0b3d51",
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [
        {
          color: "#000000",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [
        {
          color: "#146474",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          color: "#021019",
        },
      ],
    },
  ]);
  return (
    <div className="result__step">
      <div className="left">
        <div className="snake__info">
          <div className="title">
            <SemiVenemous />
            <h3>King Cobra</h3>
          </div>
          <div className="fine__information">
            <div className="notice">
              <span>Dice snake</span>
            </div>
            <div className="location">
              <Location />
              <span>Lar national park</span>
            </div>
          </div>
          <div className="description">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              consectetur dui quis arcu porta, quis iaculis nunc maximus.
              Suspendisse aliquet erat nec neque aliquam, sit amet cursus lorem
              posuere. Interdum et malesuada fames ac ante ipsum primis in
              faucibus. Praesent congue eget dolor finibus gravida. Nunc
              eleifend molestie justo at vestibulum. Vivamus molestie tincidunt
              nisl et vulputate. Curabitur ut efficitur massa. Proin neque nisl,
              interdum ac diam quis, consequat vehicula tellus. Vestibulum id
              luctus ipsum. Vivamus venenatis, velit ac dictum elementum, felis
              risus pretium est, dictum lobortis lacus nulla vitae felis. Ut nec
              leo pharetra, vestibulum orci quis, luctus turpis. Etiam venenatis
              accumsan luctus. Vivamus venenatis, velit ac dictum elementum,
              felis risus pretium est, dictum lobortis lacus nulla vitae felis.
              Ut nec leo pharetra, vestibulum orci quis, luctus turpis. Etiam
              venenatis accumsan luctus.Lorem ipsum dolor sit amet, consectetur
              adipiscing elit. Nunc consectetur dui quis arcu porta, quis
              iaculis nunc maximus. Suspendisse aliquet erat nec neque aliquam,
              sit amet cursus lorem posuere. Interdum et malesuada fames ac ante
              ipsum primis in faucibus. Praesent congue eget dolor finibus
              gravida. Nunc eleifend molestie justo at vestibulum. Vivamus
              molestie tincidunt nisl et vulputate. Curabitur ut efficitur
              massa. Proin neque nisl, interdum ac diam quis, consequat vehicula
              tellus. Vestibulum id luctus ipsum. Vivamus venenatis, velit ac
              dictum elementum, felis risus pretium est, dictum lobortis lacus
              nulla vitae felis. Ut nec leo pharetra, vestibulum orci quis,
              luctus turpis. Etiam venenatis accumsan luctus. Vivamus venenatis,
              velit ac dictum elementum, felis risus pretium est, dictum
              lobortis lacus nulla vitae felis. Ut nec leo pharetra, vestibulum
              orci quis, luctus turpis. Etiam venenatis accumsan luctus.Lorem
              ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              consectetur dui quis arcu porta, quis iaculis nunc maximus.
              Suspendisse aliquet erat nec neque aliquam, sit amet cursus lorem
              posuere. Interdum et malesuada fames ac ante ipsum primis in
              faucibus. Praesent congue eget dolor finibus gravida. Nunc
              eleifend molestie justo at vestibulum. Vivamus molestie tincidunt
              nisl et vulputate. Curabitur ut efficitur massa. Proin neque nisl,
              interdum ac diam quis, consequat vehicula tellus. Vestibulum id
              luctus ipsum. Vivamus venenatis, velit ac dictum elementum, felis
              risus pretium est, dictum lobortis lacus nulla vitae felis. Ut nec
              leo pharetra, vestibulum orci quis, luctus turpis. Etiam venenatis
              accumsan luctus. Vivamus venenatis, velit ac dictum elementum,
              felis risus pretium est, dictum lobortis lacus nulla vitae felis.
              Ut nec leo pharetra, vestibulum orci quis, luctus turpis. Etiam
              venenatis accumsan luctus.
            </p>
          </div>
        </div>
      </div>
      <div className="right">
        <div className="gallery">
          <div className="master__image">
            <img src={Snake} alt="" />
          </div>
          <Gallery />
        </div>
        <div className="location">
          <GoogleMapKmlLayer
            KmlLayers={KmlLayers}
            styles={googleMapDarkTheme ? googleMapDarkStyle : []}
          />
          <button
            onClick={() => setGoogleMapDarkTheme((prevState) => !prevState)}
          >
            toggle theme
          </button>
        </div>
      </div>
      <div className="tell__us__feedback">
        <h4>Help us get better</h4>
        <button onClick={() => props.changeStep(4)}>
          Tell us your feedback
        </button>
      </div>
    </div>
  );
}

export default ResultStep;
